import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import { generateAutocompleteItems } from '../../../utils/helper';
import masterDataService from '../../../service/masterData.service';
import { useLoader } from '../../../provider/LoaderProvider';
import InprogressDelivery from './InprogressDelivery';
import NewDelivery from './NewDelivery';
import DeliveryDocsTab from './DeliveryDocsTab';

const DeliveryPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { showLoader, hideLoader } = useLoader();
  const [autocompleteData, setAutocompleteData] = useState({
    warehouse: [],
    company: [],
    user: [],
  });
  const [autocompleteOptions, setAutocompleteOptions] = useState({
    warehouse: [],
    company: [],
    user: [],
  });

  useEffect(() => {
    const loadAutocompleteData = async () => {
      showLoader();
      try {
        const [warehouse, company, user] = await Promise.all([
          masterDataService.warehouseToForm(),
          masterDataService.companyToForm(),
          masterDataService.usersToForm(),
        ]);

        setAutocompleteData({
          warehouse: Array.isArray(warehouse) ? warehouse : [],
          company: Array.isArray(company) ? company : [],
          user: Array.isArray(user) ? user : [],
        });

        const customerCompanies = (company ?? []).filter((item) => item.active && item.customer);
        setAutocompleteOptions({
          warehouse: generateAutocompleteItems(warehouse ?? [], ['code', 'name'], 'code'),
          company: generateAutocompleteItems(customerCompanies, ['code', 'name'], 'id'),
          user: generateAutocompleteItems(user ?? [], 'nickName', 'userId'),
        });
      } finally {
        hideLoader();
      }
    };

    loadAutocompleteData();
  }, []);

  const tabs = [
    {
      id: 0,
      name: 'Bizonylatok',
      content: <DeliveryDocsTab autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 1,
      name: 'Új indítása',
      content: <NewDelivery autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 2,
      name: 'Folyamatban',
      content: <InprogressDelivery autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />,
    },
  ];

  return (
    <PhoneBase name="Delivery">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Kiszállítás
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={setActiveTab} disablePadding>
        {tabs.map((tab) => (
          <div key={tab.id} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default DeliveryPage;
